import { useGetUniversitiesQuery } from "@api/university";
import { useTranslation } from "react-i18next";

interface UniversityListProps {
  selectedUniversityId?: string;
  onSelectUniversity: (universityId: string) => void;
}

const UniversityList = ({
  selectedUniversityId,
  onSelectUniversity,
}: UniversityListProps) => {
  const { t } = useTranslation(["universityManagement"]);
  const { data: universities, isLoading } = useGetUniversitiesQuery();

  return (
    <div className="card bg-neutral shadow-sm">
      <div className="card-body">
        <h2 className="card-title mb-4 text-lg">{t("universities")}</h2>
        {isLoading ? (
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner" />
          </div>
        ) : (
          <div className="space-y-2">
            {universities?.map((uni) => (
              <button
                type="button"
                key={uni.id}
                className={`btn btn-ghost w-full justify-start text-left ${
                  selectedUniversityId === uni.id ? "btn-active" : ""
                }`}
                onClick={() => onSelectUniversity(uni.id)}
              >
                <div className="flex items-center space-x-2">
                  <div
                    className="h-4 w-4 rounded"
                    style={{ backgroundColor: uni.color }}
                  />
                  <div>
                    <div className="font-medium">{uni.shortName}</div>
                    <div className="text-sm opacity-70">{uni.fullName}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UniversityList;
